const OverviewNoneActiveIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0007 15.1663H6.00065C2.38065 15.1663 0.833984 13.6197 0.833984 9.99967V5.99967C0.833984 2.37967 2.38065 0.833008 6.00065 0.833008H10.0007C13.6207 0.833008 15.1673 2.37967 15.1673 5.99967V9.99967C15.1673 13.6197 13.6207 15.1663 10.0007 15.1663ZM6.00065 1.83301C2.92732 1.83301 1.83398 2.92634 1.83398 5.99967V9.99967C1.83398 13.073 2.92732 14.1663 6.00065 14.1663H10.0007C13.074 14.1663 14.1673 13.073 14.1673 9.99967V5.99967C14.1673 2.92634 13.074 1.83301 10.0007 1.83301H6.00065Z"
        fill="#010D1D"
      />
      <path
        d="M10.3333 12.8337C9.32 12.8337 8.5 12.0137 8.5 11.0003V5.00033C8.5 3.98699 9.32 3.16699 10.3333 3.16699C11.3467 3.16699 12.1667 3.98699 12.1667 5.00033V11.0003C12.1667 12.0137 11.3467 12.8337 10.3333 12.8337ZM10.3333 4.16699C9.87333 4.16699 9.5 4.54033 9.5 5.00033V11.0003C9.5 11.4603 9.87333 11.8337 10.3333 11.8337C10.7933 11.8337 11.1667 11.4603 11.1667 11.0003V5.00033C11.1667 4.54033 10.7933 4.16699 10.3333 4.16699Z"
        fill="#010D1D"
      />
      <path
        d="M5.66732 12.833C4.65398 12.833 3.83398 12.013 3.83398 10.9997V8.66634C3.83398 7.65301 4.65398 6.83301 5.66732 6.83301C6.68065 6.83301 7.50065 7.65301 7.50065 8.66634V10.9997C7.50065 12.013 6.68065 12.833 5.66732 12.833ZM5.66732 7.83301C5.20732 7.83301 4.83398 8.20634 4.83398 8.66634V10.9997C4.83398 11.4597 5.20732 11.833 5.66732 11.833C6.12732 11.833 6.50065 11.4597 6.50065 10.9997V8.66634C6.50065 8.20634 6.12732 7.83301 5.66732 7.83301Z"
        fill="#010D1D"
      />
    </svg>
  );
};

export default OverviewNoneActiveIcon;
